import { render, staticRenderFns } from "./DataSourcesView.vue?vue&type=template&id=500aedbc&"
import script from "./DataSourcesView.vue?vue&type=script&lang=js&"
export * from "./DataSourcesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports